'use client';

import { useApi } from '@prismo-io/core';
import useSWRMutation from 'swr/mutation';
import { kickFormation } from '../utils/kick-formation';

export const useKickFormation = () => {
  const { client } = useApi();

  return useSWRMutation(['kick-formation'], () => kickFormation(client));
};
